import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import './PublicNav.css';

interface PublicNavProps {
  onLoginClick?: () => void;
}

const PublicNav: React.FC<PublicNavProps> = ({ onLoginClick }) => {
  const { state: authState } = useAuth();
  const { state: themeState, toggleTheme } = useTheme();
  const navigate = useNavigate();

  // Don't show nav if authenticated
  if (authState.isAuthenticated) {
    return null;
  }

  const handleLogin = () => {
    if (onLoginClick) {
      onLoginClick();
    } else {
      navigate('/login');
    }
  };

  return (
    <nav className="public-nav">
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          decyx
        </Link>
        <div className="nav-links">
          <Link to="/" className="nav-link">Home</Link>
          <Link to="/how-it-works" className="nav-link">How It Works</Link>
          <Link to="/technology" className="nav-link">Technology</Link>
          <Link to="/contact-us" className="nav-link">Contact Us</Link>
          <button className="nav-login-button" onClick={handleLogin}>
            Login
          </button>
          <button
            className="nav-theme-toggle"
            onClick={toggleTheme}
            title={themeState.isDark ? 'Switch to light mode' : 'Switch to dark mode'}
            aria-label="Toggle theme"
          >
            {themeState.isDark ? (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            ) : (
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default PublicNav;

